<template>
  <div class="custom-header-container">
    <header class="header-wrapper">
      <div class="header">
        <a :href="homeUrl" class="header__logo-link">
          <img :src="logoSvg" :alt="$t('header.ovhLogo')" class="header__logo--mobile" />
          <img :src="logoPng" :alt="$t('header.ovhLogo')" class="header__logo" />
        </a>

        <ul class="header__nav">
          <li class="header__nav-item">
            <a :href="helpCenterUrl" class="header__nav-item-link">
              {{ $t('header.helpCenter') }}
            </a>
          </li>

          <li class="header__nav-item">
            <a :href="guidesUrl" class="header__nav-item-link">
              {{ $t('header.guides') }}
            </a>
          </li>

          <li class="header__nav-item">
            <a :href="travauxUrl" class="header__nav-item-link">
              {{ $t('header.travaux') }}
            </a>
          </li>
          <!-- <li class="header__nav-item">
            <a :href="backlogStatusUrl" class="header__nav-item-link">
              {{$t('header.backlogStatus')}}
            </a>
          </li> -->
        </ul>
      </div>
    </header>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta'
import { useI18n } from 'vue-i18n'

export default {
  name: 'HeaderView',
  setup() {
    const { t } = useI18n()
    useMeta({ title: t('title-tab') })
    return { t }
  },
  data() {
    return {
      homeUrl: '',
      logoSvg: '',
      logoPng: '',
      helpCenterUrl: '',
      guidesUrl: '',
      travauxUrl: '',
      backlogStatusUrl: ''
    }
  },
  created() {
    this.initializeHeader()
  },
  methods: {
    initializeHeader() {
      const lang = navigator.language
      this.logoSvg = 'https://www.ovh.com/images/logo/ovhLogoColor.svg'
      this.logoPng = 'https://www.ovh.com/fr/images/newLogos/logo-ovh.png'

      this.homeUrl = 'https://status.isp.ovhcloud.com/'

      this.helpCenterUrl =
        lang === 'fr' ? 'https://help.ovhcloud.com/fr/' : 'https://help.ovhcloud.com/en-ie'
      this.guidesUrl = lang === 'fr' ? 'https://docs.ovh.com/fr/' : 'https://docs.ovh.com/ie/en/'

      this.travauxUrl = 'https://web-cloud.status-ovhcloud.com/'

      this.backlogStatusUrl = 'http://real-time-backlog-telecom.status-ovhcloud.com/'
    }
  }
}
</script>

<style>
.custom-header-container {
  overflow-wrap: break-word;
  margin-bottom: 70px;
}
@media screen and (max-width: 650px) {
  .custom-header-container {
    margin-bottom: 60px;
  }
}
@media screen and (max-width: 450px) {
  .custom-header-container {
    margin-bottom: 50px;
  }
}
.custom-header-container .updates-dropdown-container {
  display: none;
}
.header-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: #fff;
  box-shadow: 0 0 1.25em 0.1875em rgba(0, 0, 0, 0.3);
}

.header {
  display: flex;
  position: relative;
  max-width: 90rem;
  padding-left: 1rem;
  padding-right: 2.5rem;
  margin: 0 auto;
}

.header__logo,
.header__logo--mobile {
  display: block;
  padding: 0.75rem 0;
  width: auto;
}

.header__logo--mobile {
  display: block;
  height: 3.125rem;
}

.header__logo {
  display: none;
}

.header__logo-link {
  display: flex;
  align-items: center;
  margin-right: 1.5rem;
}

.header__nav {
  display: none;
  padding: 0;
}

.header__nav-item {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0 0.75rem;
}

.header__nav-item:last-of-type {
  margin-right: 0;
}

.header__nav-item:first-of-type {
  margin-left: 0;
}
.header__nav-item--subscribe > div > a {
  font-size: 1rem;
  line-height: 1rem;
  font-weight: 600;
  text-align: center;
  display: block;
  background-color: white;
  color: #0050d7;
  border-radius: 0.5rem;
  padding: 0.5em 1em;
  transition: opacity 0.2s;
  min-width: 7.1875rem;
}
.header__nav-item--subscribe > div > a:hover {
  background-color: #bef1ff;
}
.header__nav-item--subscribe > div > a:active {
  background-color: #85d9fd;
}
.header__nav-item:nth-child(2)::after,
.header__nav-item:last-child::after {
  display: none;
}
.header__nav-item-link {
  position: relative;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  width: max-content;
}
.header__nav-item-link:hover {
  color: #fff;
  text-decoration: none;
}
.header__nav-item-link::after {
  display: 'block';
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 100%;
  height: 1px;
  background-color: #fff;
  transition: right 0.2s ease-in-out;
}
.header__nav-item-link:hover::after {
  right: 0;
}
.header__hamburger.hamburger {
  display: flex;
  align-items: center;
  padding: 0;
  outline: none;
}
@media (min-width: 50rem) {
  .header {
    height: 4.063rem;
  }
  .header-wrapper {
    background-color: #0017a4;
  }
  .header__logo--mobile {
    display: none;
  }
  .header__logo {
    display: block;
    max-height: 4.063rem;
  }
  .header__hamburger.hamburger {
    display: none;
  }
  .header__nav {
    display: flex;
    margin-left: auto;
  }
  .header__nav-item-link:hover,
  .header__nav-item-link {
    color: #fff;
  }
  .updates-dropdown {
    right: 0;
  }
}
@media (max-width: 49.99rem) {
  .updates-dropdown-container .updates-dropdown {
    position: absolute;
  }
  .header__nav {
    display: block;
    position: fixed;
    visibility: hidden;
    top: 3.125rem;
    left: -100vw;
    right: 100vw;
    bottom: 0;
    transition: all 0.4s ease;
    background-color: #fff;
    z-index: -1;
  }
  .header__nav--active {
    visibility: visible;
    left: 0;
    right: 20px;
  }
  .header__nav--active .header__nav-item {
    border-bottom: solid #fff 0.0625em;
  }
  .header__nav--active .header__nav-item:last-child {
    border-bottom: none;
  }
  .header__nav--active .header__nav-item::after {
    display: none;
  }
  .header__nav--active .header__nav-item:nth-child(2) {
    margin-right: 0;
  }
  .header__nav--active .header__nav-item--subscribe {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.8em 0;
  }
  .header__nav--active .header__nav-item-link {
    width: 100%;
    text-align: left;
    color: #00185e;
    font-weight: 700;
    padding: 0.625rem 1rem;
  }
  .header__nav-item {
    margin: 0;
  }
  .header__nav-item:first-of-type {
    margin-top: 6px;
  }
  .header__nav-item-link::after {
    content: '';
    display: block;
    border-bottom: 1px solid #e6e6e6;
    position: absolute;
    bottom: 0;
    left: 1rem;
    right: 1rem;
  }
  .header {
    height: 3.125rem;
    box-shadow: 0px 0px 6px #000e9c33;
  }
  .header::before {
    content: '';
    position: absolute;
    top: 3.125rem;
    left: 0;
    width: 100vw;
    height: calc(100vh - 3.125rem);
    background-color: rgba(0, 0, 0, 0.4);
    z-index: -2;
    transition: all 0.4s;
    opacity: 0;
    visibility: hidden;
  }
  .header--active::before {
    opacity: 1;
    visibility: visible;
  }
  .header__global-status {
    position: relative;
    z-index: -3;
  }
}

.header__global-status {
  font-size: 0.875em;
  font-weight: bold;
  text-align: center;
  background-color: #ffffff;
  padding: 1em 0;
  min-height: 3.5em;
}
</style>
